import { TComponent } from '@/lib/contentstack-sdk/types/component';

import { MlHeaderCS } from '@/components/molecules';
import { MlAbaFormCs } from '@/components/molecules/ml-aba-form/ml-aba-form.cms';
import { MlAccordionCS } from '@/components/molecules/ml-accordion/ml-accordion.cms';
import { MlCopySectionCS } from '@/components/molecules/ml-copy-section/ml-copy-section.cms';
import { MlCtaCardCS } from '@/components/molecules/ml-cta-card/ml-cta-card.cms';
import { MlServiceLocationsCS } from '@/components/molecules/ml-service-locations/ml-service-locations.cms';
import { OrFilteredGridCMS } from '@/components/organisms/or-filtered-grid/or-filtered-grid.cms';
import { OrMiniCtaBlockACS } from '@/components/organisms/or-mini-cta-block-a/or-mini-cta-block-a.cms';
import { OrMiniCtaBlockBCS } from '@/components/organisms/or-mini-cta-block-b/or-mini-cta-block-b.cms';
import { OrMiniCtaBlockCCS } from '@/components/organisms/or-mini-cta-block-c/or-mini-cta-block-c.cms';
import { OrModelHomeGridCs } from '@/components/organisms/or-model-home-grid/or-model-home-grid.cms';
import { OrPromotionalBlockCS } from '@/components/organisms/or-promotional-block/or-promotional-block.cms';
import { TmDesignCenterDetailCMS } from '@/components/templates/tm-design-center-detail/tm-design-center-detail.cms';
import { OrVideoHeroCS } from '@/components/organisms/or-video-hero/or-video-hero.cms';
import { TmHomePlanDetailsCMS } from '@/components/templates/tm-home-plan-detail/tm-home-plan-detail.cms';
import { TmModelHomeDetailCMS } from '@/components/templates/tm-model-home-detail/tm-model-home-detail.cms';
import { OrFeaturedVideoCS } from '@/components/organisms/or-featured-video/or-featured-video.cms';
import { OrContentBlockCS } from '@/components/organisms/or-content-block/or-content-block.cms';
import { OrStatsListCMS } from '@/components/organisms/or-stats-list/or-stats-list.cms';
import { OrFaqListCS } from '@/components/organisms/or-faq-list/or-faq-list.cms';
import { OrTestimonialBlockCS } from '@/components/organisms/or-testimonial-block/or-testimonial-block.cms';
import { OrContentMediaBlockCS } from '@/components/organisms/or-content-media-block/or-content-media-block.cms';
import { OrThreeBlocksCMS } from '@/components/organisms/or-three-blocks/or-three-blocks.cms';
import { OrCardsListCMS } from '@/components/organisms/or-cards-list/or-cards-list.cms';
import { OrHomePlansCarouselCMS } from '@/components/organisms/or-home-plans-carousel/or-home-plans-carousel.cms';
import { OrDesignStudioBlockCMS } from '@/components/organisms/or-design-studio-block/or-design-studio-block.cms';
import { OrFloorPlanViewerCMS } from '@/components/organisms/or-floorplan-viewer/or-floorplan-viewer.cms';
import { OrDisclaimerTextCMS } from '@/components/organisms/or-disclaimer-text/or-disclaimer-text.cms';
import { SeriesModelHomeGridCS } from '@/components/templates/tm-home-plan-detail/series-model-home-grid/tm-home-plan-detail-series-model-home-grid.cms';
import { OrMiniCtaBlockDCMS } from '@/components/organisms/or-mini-cta-block-d/or-mini-cta-block-d.cms';
import { OrGenericContentCMS } from '@/components/organisms/or-generic-content/or-generic-content.cms';

import RenderClientOnlyComponentsWrapper from './RenderClientComponents';
import { TmLanding } from '@/components/templates/tm-landing/tm-landing';

export default function RenderAllComponents({
  body,
  showAbaForm = false,
}: {
  body: TComponent[];
  showAbaForm?: boolean;
}) {
  return (
    <>
      {showAbaForm && <MlAbaFormCs />}
      {body?.map((component, key) => {
        // console.log('component._content_type_uid:', component._content_type_uid);
        //TODO: This needs to be changed to an IF statement
        switch (component._content_type_uid) {
          case 'mapping_tool':
          case 'lead_generation_form':
            // Render client-only components inside the client wrapper
            return (
              <RenderClientOnlyComponentsWrapper
                body={component}
                key={component.uid || key}
              />
            );
          case 'featured_video':
            return <OrFeaturedVideoCS block={component} key={key} />;
          case 'filtered_grid':
            return <OrFilteredGridCMS block={component} key={key} />;
          case 'video_hero':
            return <OrVideoHeroCS block={component} key={component?.uid} />;
          case 'infographic_block':
            return <OrContentBlockCS block={component} key={key} />;
          case 'or-statslist':
            return <OrStatsListCMS key={key} {...component} />;
          case 'accordion':
            return <MlAccordionCS block={component} key={key} />;
          case 'faq_list':
            return <OrFaqListCS block={component} key={key} />;
          case 'testimonial_block':
            return <OrTestimonialBlockCS block={component} key={key} />;
          case 'content_media_block':
            return <OrContentMediaBlockCS block={component} key={key} />;
          case 'or-cardslist':
            return <OrCardsListCMS key={key} {...component} />;
          case 'or-homeplanscarousel':
            return <OrHomePlansCarouselCMS key={key} {...component} />;
          case 'promotional_block':
            return <OrPromotionalBlockCS block={component} key={key} />;
          case 'or-three-blocks':
            return <OrThreeBlocksCMS key={key} {...component} />;
          case 'home_plan_detail':
            return <TmHomePlanDetailsCMS block={component} key={key} />;
          case 'landing':
            return <TmLanding block={component} key={key} />;
          case 'or-designstudioblock':
            return <OrDesignStudioBlockCMS {...component} key={key} />;
          case 'mini_cta_block':
            return <OrMiniCtaBlockACS block={component} key={key} />;
          case 'tm_design_studio':
            return <TmDesignCenterDetailCMS block={component} key={key} />;
          case 'tm_model_home_detail':
            return <TmModelHomeDetailCMS block={component} key={key} />;
          case 'or-floor_plan_viewer':
            return <OrFloorPlanViewerCMS {...component} key={key} />;
          case 'copy_section':
            return <MlCopySectionCS {...component} key={key} />;
          case 'model_home_grid':
            return <OrModelHomeGridCs key={key} {...component} />;
          case 'mini_cta_block_b':
            return <OrMiniCtaBlockBCS key={key} block={component} />;
          case 'mini_cta_block_c':
            return <OrMiniCtaBlockCCS key={key} block={component} />;
          case 'or-small-header':
            return <MlHeaderCS key={key} {...component} />;
          case 'cta_cards_1_3_4':
            return <MlCtaCardCS key={key} block={component} />;
          case 'service_locations':
            return <MlServiceLocationsCS key={key} block={component} />;
          case 'or-disclaimer_text':
            return <OrDisclaimerTextCMS key={key} {...component} />;
          case 'series_model_home_grid':
            return <SeriesModelHomeGridCS key={key} block={component} />;
          case 'mini_cta_block_d_2_2_7':
            return <OrMiniCtaBlockDCMS key={key} {...component} />;
          case 'generic_content':
            return <OrGenericContentCMS key={key} {...component} />;
          default:
            return null;
        }
      })}
    </>
  );
}
